import { cnFlag, enFlag, frFlag } from '@/assets/icons';

export interface LanguageInfo {
  value: string;
  label: string;
  flag: string;
}

export const languagesInfo: LanguageInfo[] = [
  { value: 'fr', label: 'FR', flag: frFlag },
  { value: 'en', label: 'EN', flag: enFlag },
  // { value: 'ja', label: '日本語', flag: 'jpFlag' },
  { value: 'zh-cn', label: '中文', flag: cnFlag }
];

export const languageMapping: { [key: string]: string } = {
  'zh-Hans-CN': 'zh-cn'
};
